import type { ChangeEvent, ComponentType } from 'react'

import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDTextarea from '@/shared/components/SDComponentsNewDesign/SDTextarea/SDTextarea'
import type { SDIconProps } from '@/shared/icons/SDIcon'
import PollFaceButton from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/BoardPoll/PollFaceButton/PollFaceButton'
import { CommentLabel, OptionalMark, PollFaces, PollFootnote, PollFormColumn } from './styled-components'
import type { PollCommentOverrides, PollFootnoteTone } from './styled-components'

interface PollFace {
  score: number
  Icon: ComponentType<SDIconProps>
  colorKey: string
  softColorKey: string
  label: string
  selected: boolean
  dimmed: boolean
  onSelect: () => void
}

interface PollFormProps {
  hidden: boolean
  title: string
  faces: PollFace[]
  commentId: string
  commentLabel: string
  optionalLabel: string
  commentPlaceholder: string
  comment: string
  commentMaxLength: number
  commentOverrides: typeof PollCommentOverrides
  onCommentChange: (event: ChangeEvent<HTMLTextAreaElement>) => void
  submitLabel: string
  submitDisabled: boolean
  onSubmit: () => void
  footnote: string
  footnoteTone: PollFootnoteTone
}

const PollForm = ({
  hidden,
  title,
  faces,
  commentId,
  commentLabel,
  optionalLabel,
  commentPlaceholder,
  comment,
  commentMaxLength,
  commentOverrides,
  onCommentChange,
  submitLabel,
  submitDisabled,
  onSubmit,
  footnote,
  footnoteTone,
}: PollFormProps) => {
  if (hidden) {
    return null
  }

  return (
    <PollFormColumn>
      <PollFaces role='group' aria-label={title}>
        {faces.map(face => (
          <PollFaceButton key={face.score} {...face} />
        ))}
      </PollFaces>
      <CommentLabel htmlFor={commentId}>
        <span>
          {commentLabel} <OptionalMark>{optionalLabel}</OptionalMark>
        </span>
        {/* @ts-expect-error SDTextarea is a JS component without TS types */}
        <SDTextarea
          id={commentId}
          value={comment}
          maxLength={commentMaxLength}
          placeholder={commentPlaceholder}
          onChange={onCommentChange}
          overrides={commentOverrides}
        />
      </CommentLabel>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton block disabled={submitDisabled} onClick={onSubmit}>
        {submitLabel}
      </SDButton>
      <PollFootnote role='status' $tone={footnoteTone}>
        {footnote}
      </PollFootnote>
    </PollFormColumn>
  )
}

export default PollForm
